module.exports = __webpack_public_path__ + "bf836554bc4fe5ef4f106d14728929f2.png";